<template>
  <section>
    <div class="reply">
      <form @submit.prevent="submitTask">
        <div class="inputbox">
          <label>Task</label
          ><input type="text" v-model.trim="task" @blur="clearValidation" />
        </div>
        <div class="inputbox">
          <label>Task Description</label
          ><textarea v-model.trim="desc" @blur="clearValidation"></textarea>
        </div>
        <div class="inputbox">
          <label>Assigned To</label>
          <div class="reply">
            <span
              class="selectedName"
              v-for="(asign, index) in assignTo"
              index
              :key="asign"
              >{{ asign.name
              }}<span class="remove" @click="removeName(index)">x</span></span
            >
            <select class="selectOpt" @blur="clearValidation">
              <option selected>Select Employee Name</option>
              <option
                v-for="employee in employees"
                :key="employee.id"
                :value="employee.id"
                @click="selectEmp({ name: employee.name, id: employee.id })"
                >{{ employee.name }}</option
              >
            </select>
          </div>
        </div>
        <span class="warning" v-if="!isValid">Please fill all field..</span>
        <div class="btn"><base-button>Add Task</base-button></div>
      </form>
    </div>
  </section>
</template>

<script>
export default {
  props: ["projectId", "data"],
  data() {
    return {
      desc: "",
      task: "",
      assignTo: [],
      mode: true,
      isValid: true,
      dateTime: new Date(),
    };
  },
  emits: ["new-task"],
  computed: {
    employees() {
      return this.$store.getters["employees/getEmployees"];
    },
  },
  created() {
    this.selectEmployee();
  },
  methods: {
    removeName(indexnum) {
      this.assignTo.splice(indexnum, 1);
    },

    selectEmp(employee) {
      this.assignTo.push(employee);
    },
    async selectEmployee() {
      await this.$store.dispatch("employees/setEmployees");
    },
    submitTask() {
      //console.log(this.data);
      this.isValid = true;
      if (this.desc === "" || this.task === "" || this.assignTo === "") {
        this.isValid = false;
        return;
      }
      const taskData = {
        task: this.task,
        description: this.desc,
        mode: this.mode,
        assignTo: this.assignTo,
      };
      this.$emit("new-task", taskData);
      (this.task = ""),
        (this.desc = ""),
        (this.mode = true),
        (this.assignTo = []);
    },
    clearValidation() {
      this.isValid = true;
    },
  },
};
</script>

<style scoped>
.remove {
  background: #fff;
  color: #313131;
  border-radius: 100px;
  padding: 2px 7px;
  cursor: pointer;
  margin-left: 10px;
}
.selectedName {
  background: #313131;
  padding: 4px 10px;
  margin-right: 10px;
  color: #fff;
  border-radius: 2px;
}
.reply {
  width: 98%;
  float: left;
  margin: 0px 1%;
  padding: 20px;
  border: 1px solid #c1c1c1;
  box-sizing: border-box;
  margin-top: 20px;
}
.inputbox {
  float: left;
  width: 100%;
  margin-bottom: 15px;
  text-align: left;
}
label {
  width: 100%;
  text-align: left;
}
.inputbox textarea,
.inputbox input,
.selectOpt[type="text"] {
  width: 100%;
  border: 1px solid #c1c1c1;
  padding: 12px;
  box-sizing: border-box;
  font-size: 14px;
  float: left;
}
.btn {
  float: right;
  text-align: center;
  width: 100%;
}
.warning {
  color: red;
  padding: 10px 0px;
}
</style>
